module.exports = __webpack_public_path__ + "7fa27dee3773980bd5d67bbe5ae28a72.png";